import axios from "axios";
import { Config } from "../config";
import apiClient from "./apiClient";
import { IPresignResponse } from "../types/podcastType";

// Generic S3 upload: get a presigned PUT URL from the backend, upload the file
// directly to S3, return the public URL of the uploaded file.
export const uploadFileToS3 = async (
  file: File,
  folder: string,
): Promise<string> => {
  const presignRes = await apiClient.instance.post<IPresignResponse>(
    Config.endPoint.uploadFileS3Presign,
    {
      filename: file.name,
      contentType: file.type || "application/octet-stream",
      folder,
    },
  );

  const { uploadUrl, publicUrl } = presignRes.data;

  await axios.put(uploadUrl, file, {
    headers: { "Content-Type": file.type || "application/octet-stream" },
  });

  return publicUrl;
};
